// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3PVEx","label":"CategoryService_label__1DQpq","location":"CategoryService_location__r-sSG"};